module.exports = require("react-syntax-highlighter/dist/esm/styles/prism/coy");